type TDolarBlue = {
  compra: number;
  venta: number;
  casa: string;
  nombre: string;
  fechaActualizacion: string;
};


function ValueCalculator (price: number) {
    return fetch("https://dolarapi.com/v1/dolares/blue")
    .then(response => {
      if(response.ok)
      {
        return response.json();
      }
      throw response;
    })
    .then((data) => {      
      data = (data as TDolarBlue).venta
      return Math.round(data * price);
    }
    )
    .catch((err) => {
      console.log(err)
     return Math.round(1000 * price)
    } 
    );
  }

export default ValueCalculator;
